import { useState } from 'react'
import PropTypes from 'prop-types'
import PageHeader from './PageHeader'
import Footer from './Footer'
import AdminFeedback from './AdminFeedback'
import AdminHelpConversations from './AdminHelpConversations'
import AdminInvites from './AdminInvites'
import AdminUsers from './AdminUsers'

const AdminPanel = ({ onBack, onLogout }) => {
  const [activeTab, setActiveTab] = useState('feedback')

  const tabs = [
    { id: 'feedback', label: 'Feedback', icon: (
      <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M7 8h10M7 12h4m1 8l-4-4H5a2 2 0 01-2-2V6a2 2 0 012-2h14a2 2 0 012 2v8a2 2 0 01-2 2h-3l-4 4z" />
      </svg>
    )},
    { id: 'help', label: 'Help Conversations', icon: (
      <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M8.228 9c.549-1.165 2.03-2 3.772-2 2.21 0 4 1.343 4 3 0 1.4-1.278 2.575-3.006 2.907-.542.104-.994.54-.994 1.093m0 3h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
      </svg>
    )},
    { id: 'invites', label: 'Invites', icon: (
      <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z" />
      </svg>
    )},
    { id: 'users', label: 'Users', icon: (
      <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 4.354a4 4 0 110 5.292M15 21H3v-1a6 6 0 0112 0v1zm0 0h6v-1a6 6 0 00-9-5.197M13 7a4 4 0 11-8 0 4 4 0 018 0z" />
      </svg>
    )}
  ]

  return (
    <div className="min-h-screen bg-gray-950 flex flex-col">
      <PageHeader
        title="Admin Panel"
        subtitle="Manage feedback, invites, and users"
        onLogout={onLogout}
        compact
        navItems={
          <button
            onClick={onBack}
            className="rounded-md bg-gray-900 px-3 py-2 text-sm font-medium text-white hover:bg-gray-800"
          >
            ← Back to Dashboard
          </button>
        }
      />

      <main className="flex-1 mx-auto max-w-7xl w-full px-4 sm:px-6 lg:px-8 py-8">
        {/* Tab Navigation */}
        <div className="border-b border-gray-700 mb-6">
          <nav className="-mb-px flex space-x-8" aria-label="Tabs">
            {tabs.map((tab) => (
              <button
                key={tab.id}
                onClick={() => setActiveTab(tab.id)}
                className={`flex items-center gap-2 py-4 px-1 border-b-2 font-medium text-sm transition-colors ${
                  activeTab === tab.id
                    ? 'border-purple-500 text-purple-400'
                    : 'border-transparent text-gray-400 hover:text-gray-300 hover:border-gray-600'
                }`}
              >
                {tab.icon}
                {tab.label}
              </button>
            ))}
          </nav>
        </div>

        {/* Tab Content */}
        {activeTab === 'feedback' && <AdminFeedback embedded />}
        {activeTab === 'help' && <AdminHelpConversations embedded />}
        {activeTab === 'invites' && <AdminInvites />}
        {activeTab === 'users' && <AdminUsers />}
      </main>

      <Footer variant="authenticated" />
    </div>
  )
}

AdminPanel.propTypes = {
  onBack: PropTypes.func.isRequired,
  onLogout: PropTypes.func
}

export default AdminPanel
